import BigNumber from 'bignumber.js/bignumber'
import { BIG_TEN } from 'utils/bigNumber'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const BASE_FTM_SCAN_URLS = {
  250: 'https://ftmscan.com',
  4002: 'https://testnet.ftmscan.com',
}

export const KCC_BLOCK_TIME = 0.9

export const LOCKED_FOR_NFT = 7350000
export const LOCKED_OF_TEAM = 1274655.6
export const DMD_PER_SECOND = new BigNumber(0.5)
export const SECOND_PER_DAY = 60 * 60 * 24
export const SECOND_PER_YEAR_NUM = SECOND_PER_DAY * 365
export const BLOCKS_PER_YEAR = new BigNumber(SECOND_PER_YEAR_NUM / KCC_BLOCK_TIME)
export const SECOND_PER_YEAR = new BigNumber(SECOND_PER_YEAR_NUM)
export const BLOCKS_PER_DAY = SECOND_PER_DAY / KCC_BLOCK_TIME
export const DMD_PER_YEAR = DMD_PER_SECOND.times(SECOND_PER_YEAR_NUM)
export const BASE_URL = 'https://www.darkmatterdefi.com'
export const BASE_EXCHANGE_URL = 'https://spookyswap.finance'
export const BASE_EXCHANGE_INFO_URL = 'https://info.spookyswap.finance'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_EXCHANGE_URL}/add`
export const BASE_LIQUIDITY_POOL_URL = `${BASE_EXCHANGE_URL}/pool`
export const BASE_FTM_SCAN_URL = 'https://ftmscan.com'
export const LOTTERY_MAX_NUMBER_OF_TICKETS = 50
export const LOTTERY_TICKET_PRICE = 1
export const DEFAULT_TOKEN_DECIMAL = BIG_TEN.pow(18)
export const DEFAULT_GAS_LIMIT = 400000
export const SMALL_GAS_LIMIT = 200000
export const MEDIUM_GAS_LIMIT = 300000
export const LARGE_GAS_LIMIT = 700000
export const XLARGE_GAS_LIMIT = 800000
export const XXLARGE_GAS_LIMIT = 1200000
export const SUPER_LARGE_GAS_LIMIT = 7000000
// export const XLARGE_GAS_LIMIT = 1200000
// export const XXLARGE_GAS_LIMIT = 2000000
export const DEFAULT_GAS_PRICE = 5
export const SUSHI_BASE_URL = 'https://app.sushi.com'
export const SUSHI_ANALYTICS_URL = 'https://analytics-ftm.sushi.com'
export const NIPPLE_BASE_URL = 'https://exchange.nipplelabs.finance/#/'
export const NIPPLE_ANALYTICS_URL = 'https://info.nipplelabs.finance/'
export const JET_BASE_URL = 'https://fantom-exchange.jetswap.finance/'
export const JET_ANALYTICS_URL = 'https://fantom-info.jetswap.finance/'
export const SPIRIT_BASE_URL = 'https://swap.spiritswap.finance/#'
export const SPIRIT_ANALYTICS_URL = 'https://info.spiritswap.finance'
export const YOSHI_BASE_URL = 'https://yoshi.exchange'
export const NFTKEY_BASE_URL = 'https://nftkey.app'
export const PAINTSWAP_BASE_URL = 'https://paintswap.finance'
export const PAINTSWAP_API_URL = 'https://api.paintswap.finance'
export const OPERAHOUSE_BASE_URL = 'https://operahouse.online'
export const TOFU_BASE_URL = 'https://tofunft.com'
export const DEAD_ADDRESS = '0x000000000000000000000000000000000000dead'
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const PINATA_BASE_URL = 'https://ipfs.io/ipfs'
export const DMD_PINATA_BASE_URL = 'https://dmd.mypinata.cloud/ipfs'
export const OPERAHOUSE_GRAPHQL_URL = 'https://api.thegraph.com/subgraphs/name/patriotze/operahouse2'
